var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BCol, BCard, BOverlay } from 'bootstrap-vue';
import { getUnitPrice } from 'ts/modules/pricing';
let UpsellUnitProduct = class UpsellUnitProduct extends Vue {
    loading = true;
    size;
    product;
    basePrice;
    quantity;
    pricing = {
        base_unit_price: '0.00',
        ex_vat_base_unit_price: '0.00',
        unit_price: '0.00',
        total_price: '0.00',
        unit_discount: '0.00',
        total_discount: '0.00'
    };
    get href() {
        return `/diy-framing/accessories/${this.product.category?.type?.slug}/${this.product.meta?.slug}`;
    }
    get priceIncrease() {
        return (parseFloat(this.pricing.unit_price) - parseFloat(this.basePrice)).toFixed(2);
    }
    async getPrice() {
        if (!this.product.sku) {
            return;
        }
        this.loading = true;
        try {
            // Get the price for this product
            this.pricing = await getUnitPrice(this.product.sku, null, this.quantity);
        }
        catch (e) {
            console.log(e);
        }
        this.loading = false;
    }
    mounted() {
        this.getPrice();
    }
};
__decorate([
    Prop(Object)
], UpsellUnitProduct.prototype, "size", void 0);
__decorate([
    Prop(Object)
], UpsellUnitProduct.prototype, "product", void 0);
__decorate([
    Prop(String)
], UpsellUnitProduct.prototype, "basePrice", void 0);
__decorate([
    Prop(Number)
], UpsellUnitProduct.prototype, "quantity", void 0);
__decorate([
    Watch('basePrice'),
    Watch('quantity')
], UpsellUnitProduct.prototype, "getPrice", null);
UpsellUnitProduct = __decorate([
    Component({
        components: {
            BOverlay, BCol, BCard
        }
    })
], UpsellUnitProduct);
export default UpsellUnitProduct;
